import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Alert, AlertType } from './alert.model';

@Injectable({ providedIn: 'root' })
export class AlertService {

  private nextId = 0;
  private alertsSubject = new BehaviorSubject<Alert[]>([]);

  alerts$ = this.alertsSubject.asObservable();

  error(message: string): void {
    this.add('error', message);
  }

  warning(message: string): void {
    this.add('warning', message);
  }

  info(message: string): void {
    this.add('info', message);
  }

  remove(id: number): void {
    const alerts = this.alertsSubject.value.filter(a => a.id !== id);
    this.alertsSubject.next(alerts);
  }

  private add(type: AlertType, message: string): void {
    const alert: Alert = { id: this.nextId++, type, message };
    this.alertsSubject.next([...this.alertsSubject.value, alert]);

    const timeout = type === 'error' ? 8000 : 5000;
    setTimeout(() => this.remove(alert.id), timeout);
  }
}
